module.exports = __webpack_public_path__ + "static/media/info-icon.e8be7ef1.svg";